/**
 * Extrae bytes PDF del tag Encapsulated Document (0042,0011).
 */
import * as dicomParser from 'dicom-parser'
import {
  ENCAPSULATED_PDF_SOP,
  isEncapsulatedPdfSop,
} from './isNonImageInstance'

const TAG_ENCAPSULATED_DOCUMENT = 'x00420011'
const TAG_MIME_TYPE = 'x00420012'
const TAG_SOP_CLASS = 'x00080016'

/**
 * @param {ArrayBuffer|Uint8Array} buffer Part-10 o dataset
 * @returns {{ bytes: Uint8Array, mimeType: string, sopClassUID: string }}
 */
export function extractEncapsulatedPdf(buffer) {
  if (!buffer) {
    throw new Error('Buffer DICOM vacío')
  }
  const byteArray =
    buffer instanceof Uint8Array
      ? buffer
      : new Uint8Array(buffer)

  if (!byteArray.length) {
    throw new Error('Buffer DICOM vacío')
  }

  let dataSet
  try {
    dataSet = dicomParser.parseDicom(byteArray)
  } catch (e) {
    throw new Error(
      (e && e.message) || 'No se pudo parsear DICOM Encapsulated PDF'
    )
  }

  const sopClassUID = String(
    (dataSet.string && dataSet.string(TAG_SOP_CLASS)) || ''
  ).trim()
  if (sopClassUID && !isEncapsulatedPdfSop(sopClassUID)) {
    throw new Error(
      `SOP Class no es Encapsulated PDF: ${sopClassUID || '(vacío)'}`
    )
  }

  const mimeType = String(
    (dataSet.string && dataSet.string(TAG_MIME_TYPE)) || 'application/pdf'
  )
    .trim()
    .toLowerCase()
  if (mimeType && mimeType !== 'application/pdf' && mimeType.indexOf('pdf') < 0) {
    throw new Error(`MIME TypeOfEncapsulatedDocument no es PDF: ${mimeType}`)
  }

  const el = dataSet.elements && dataSet.elements[TAG_ENCAPSULATED_DOCUMENT]
  if (!el || el.length <= 0) {
    throw new Error('Falta Encapsulated Document (0042,0011)')
  }

  const start = el.dataOffset
  const len = el.length
  // OB puede llevar padding 0x00 al final
  let end = start + len
  const slice = byteArray.subarray(start, end)
  let bytes = new Uint8Array(slice)
  if (bytes.length && bytes[bytes.length - 1] === 0) {
    bytes = bytes.subarray(0, bytes.length - 1)
  }
  if (bytes.length < 5) {
    throw new Error('Encapsulated Document demasiado corto')
  }
  // %PDF
  if (
    bytes[0] !== 0x25 ||
    bytes[1] !== 0x50 ||
    bytes[2] !== 0x44 ||
    bytes[3] !== 0x46
  ) {
    throw new Error('Encapsulated Document no empieza con %PDF')
  }

  return {
    bytes,
    mimeType: 'application/pdf',
    sopClassUID: sopClassUID || ENCAPSULATED_PDF_SOP,
  }
}

/**
 * @param {ArrayBuffer|Uint8Array} buffer
 * @returns {Blob}
 */
export function extractEncapsulatedPdfBlob(buffer) {
  const { bytes, mimeType } = extractEncapsulatedPdf(buffer)
  return new Blob([bytes], { type: mimeType })
}
